<div class="uk-section work-section">
  <div class="uk-container">
    <h1 class="uk-heading-line">
      <span>Work</span>
    </h1>

    <div class="work-tabs-shell">
      <button
        type="button"
        class="work-tabs-arrow work-tabs-arrow-left"
        aria-label="Scroll work experience left"
        (click)="scrollTabs('left')"
      ></button>

      <div
        #workTabs
        class="work-tabs"
        role="tablist"
        aria-label="Work experience"
      >
        <button
          *ngFor="let experience of experiences; let i = index"
          type="button"
          class="work-tab"
          [class.work-tab-adjacent]="getExperienceDistance(i) === 1"
          [class.work-tab-distant]="getExperienceDistance(i) === 2"
          [class.work-tab-far]="getExperienceDistance(i) > 2"
          role="tab"
          [class.work-tab-active]="experience.id === activeExperienceId"
          [attr.aria-selected]="experience.id === activeExperienceId"
          [attr.aria-controls]="'work-panel-' + experience.id"
          (click)="setActiveExperience(experience.id, $event)"
        >
          {{ experience.label }}
        </button>
      </div>

      <button
        type="button"
        class="work-tabs-arrow work-tabs-arrow-right"
        aria-label="Scroll work experience right"
        (click)="scrollTabs('right')"
      ></button>
    </div>

    <section
      class="work-panel uk-animation-slide-bottom-small"
      role="tabpanel"
      [id]="'work-panel-' + activeExperience.id"
    >
      <div class="work-panel-grid">
        <div class="work-identity">
          <div class="work-identity-header">
            <img
              *ngIf="activeExperience.logo; else logoPlaceholder"
              class="work-logo"
              [src]="activeExperience.logo"
              [alt]="activeExperience.company + ' logo'"
            />
            <ng-template #logoPlaceholder>
              <div class="work-logo work-logo-placeholder" aria-hidden="true">
                {{ activeExperience.initials }}
              </div>
            </ng-template>

            <h2>{{ activeExperience.company }}</h2>
          </div>

          <div
            class="work-role"
            *ngFor="let role of activeExperience.roles; let i = index"
            [class.work-role-primary]="i === 0"
          >
            <p class="work-role-title">{{ role.title }}</p>
            <p *ngIf="role.note" class="work-role-note">{{ role.note }}</p>
            <p class="work-role-time">
              {{ role.time }}
              <span *ngIf="role.location" class="work-role-location">
                {{ role.location }}
              </span>
            </p>
          </div>
        </div>

        <div class="work-description">
          <h3>Overview</h3>
          <p>{{ activeExperience.description }}</p>

          <div
            *ngIf="activeExperience.featuredPublication"
            class="work-publication"
          >
            <h3>Publication</h3>
            <a [href]="activeExperience.featuredPublication.url">
              <span>{{ activeExperience.featuredPublication.label }}</span>
              {{ activeExperience.featuredPublication.title }}
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
